import React from 'react';
import { FaHome, FaPalette, FaCamera, FaBox, FaGift, FaChartBar } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaHome />,
  2: <FaPalette />,
  3: <FaCamera />,
  4: <FaBox />,
  5: <FaGift />,
  6: <FaChartBar />
};

const HomeIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="home"
      gradient="#667eea 0%, #764ba2 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default HomeIndustryPage;

